<template>
    <div class="slide-card-ghost">
        <span class="slide-index ml-1">
            {{ index + 1 }}
        </span>

        <span class="waiting">
            {{ $translate('waiting_for_your_next_patient').toUpperCase() }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'SlideCardGhost',
    props: {
        index: {
            type: Number,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.slide-card-ghost {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    .slide-index {
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        color: $light;
    }
    .waiting {
        font-size: 13pt;
        color: $dark;
    }
}
</style>
